// extracted by css-extract-rspack-plugin
export default {"cls1":"SelectionCitation-cls1_Tdz","cls2":"SelectionCitation-cls2_P8o SelectionCitation-cls1_Tdz"};